// extracted by mini-css-extract-plugin
export var cataboom = "embeddedContent-module--cataboom--95d8b";
export var contentWrapper = "embeddedContent-module--content-wrapper--bd613";
export var embeddedContent = "embeddedContent-module--embedded-content--644c1";
export var flipsnack = "embeddedContent-module--flipsnack--75f96";
export var video = "embeddedContent-module--video--34985";